/* eslint-disable indent */
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme, hexToRgba } from "utils/styling/colours";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0 2rem 0.5rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 100vw;
    width: 100%;
    max-height: 90vh;
    ${device.md} {
        max-width: 80vw;
        max-height: 90vh;
    }
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

interface BackgroundImageWrapperProps {
    width: number;
    height: number;
}

export const BackgroundImageWrapper = styled.div<BackgroundImageWrapperProps>`
    position: relative;
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    max-width: 100vw;
    ${device.md} {
        max-width: 80vw;
        max-height: 80vh;
    }
`;

export const StyledCanvas = styled.canvas`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: ${(props) => props.width}px;
    height: ${(props) => props.height}px;
    max-width: 100vw;
    ${device.md} {
        max-width: 80vw;
        max-height: 80vh;
    }
`;

export const Toolbar = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    background: linear-gradient(
        145deg,
        ${colourScheme.primaryDark},
        ${hexToRgba(colourScheme.primary, 0.8)}
    );
    padding: 0.5rem;
    border-radius: 0.5rem;
`;

export const ToolButton = styled.button<{ isSelected?: boolean }>`
    padding: 0.5rem 1.25rem;
    background: ${(props) =>
        props.isSelected
            ? `linear-gradient(145deg, ${hexToRgba(
                  colourScheme.successLight,
                  0.9
              )}, ${hexToRgba(colourScheme.successDark, 0.9)})`
            : `linear-gradient(145deg, ${hexToRgba(
                  colourScheme.primary,
                  0.7
              )}, ${hexToRgba(colourScheme.primaryLight, 0.8)})`};
    color: ${colourScheme.fullWhite};
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    transition:
        background 0.3s ease,
        transform 0.2s ease;

    &:hover {
        background: ${(props) =>
            props.isSelected
                ? `linear-gradient(145deg, 
                ${hexToRgba(colourScheme.successLight, 0.9)}, 
                  ${hexToRgba(colourScheme.successDark, 0.9)})`
                : `${colourScheme.primaryLight}`};
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }

    &:disabled {
        background: ${hexToRgba(colourScheme.primary, 0.5)};
        color: ${hexToRgba(colourScheme.fullWhite, 0.5)};
        cursor: not-allowed;
        transform: none;
        &:hover {
            background: ${hexToRgba(colourScheme.primary, 0.5)};
            transform: none;
        }
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
`;

export const CustomDialog = styled(Dialog)`
    & .MuiPaper-root {
        background-color: ${colourScheme.primaryDark};
        color: ${colourScheme.white};
        border-radius: 0.5rem;
        padding: 2rem;
        width: 100%;
        height: auto;
        max-width: 100vw;
        ${device.md} {
            max-width: 80vw;
            max-height: 80vh;
        }

        ${device.lg} {
            max-width: 60vw;
            max-height: 80vh;
        }

        ${device.xl} {
            max-width: 40vw;
        }
    }
`;

export const CustomDialogTitle = styled(DialogTitle)`
    font-size: 1.5rem;
    border-bottom: 1px solid ${colourScheme.primaryLight};
    padding-bottom: 1rem;
    margin-bottom: 1rem;
`;

export const CustomDialogContent = styled(DialogContent)`
    font-size: 1rem;
    color: ${colourScheme.white};
    padding: 1rem;
    line-height: 1.5;
    overflow-wrap: break-word;
`;

export const CustomDialogActions = styled(DialogActions)`
    padding-top: 1rem;
    border-top: 1px solid ${colourScheme.primaryLight};
`;

export const GoldCost = styled.span`
    color: gold;
    font-size: 0.9em;
    margin-left: 0.5rem;
`;
